import { useTranslation } from "react-i18next";
import {
    ActionIcon,
    Burger,
    Flex,
    Group,
    Header,
    Image,
    MediaQuery,
    Menu,
    Tooltip,
    useMantineColorScheme,
    useMantineTheme,
} from "@mantine/core";
import { useOs } from "@mantine/hooks";
import { IconMoonStars, IconSun } from "@tabler/icons-react";

import { ClientLocale } from "../../types";
import { resolveCountryCode } from "../../utils/helpers";

export interface HeaderComponentProps {
    isNavbarOpened: boolean;
    setIsNavbarOpened: (value: boolean) => void;
}

export const HeaderComponent = ({ setIsNavbarOpened, isNavbarOpened }: HeaderComponentProps) => {
    const { t, i18n } = useTranslation(["common"]);

    const os = useOs();

    const theme = useMantineTheme();
    const { colorScheme, toggleColorScheme } = useMantineColorScheme();

    return (
        <Header height={{ base: 70, md: 70 }} p="md">
            <Group px={20} position="apart" noWrap={true} style={{ height: "100%" }}>
                <MediaQuery largerThan="sm" styles={{ display: "none" }}>
                    <Burger
                        mr="xl"
                        size="sm"
                        color={theme.colors.gray[6]}
                        opened={isNavbarOpened}
                        onClick={() => setIsNavbarOpened(!isNavbarOpened)}
                    />
                </MediaQuery>
                <Image width="auto" height={40} src="/images/logo_client_zone.svg" />
                <Flex align="center" justify="flex-end">
                    <Menu radius="md" position="bottom-end">
                        <Menu.Target>
                            <ActionIcon size={42} variant="subtle">
                                <Image
                                    src={`/images/flags/${resolveCountryCode(i18n.language)}.svg`}
                                    width="auto"
                                    height={20}
                                    radius="sm"
                                />
                            </ActionIcon>
                        </Menu.Target>
                        <Menu.Dropdown>
                            {Object.values(ClientLocale).map((locale, index) => (
                                <Menu.Item
                                    key={`${index}${locale}`}
                                    icon={
                                        <Image
                                            src={`/images/flags/${resolveCountryCode(locale)}.svg`}
                                            width="auto"
                                            height={18}
                                            radius="sm"
                                        />
                                    }
                                    onClick={() => i18n.changeLanguage(locale)}
                                >
                                    {t(`lang_${locale}`)}
                                </Menu.Item>
                            ))}
                        </Menu.Dropdown>
                    </Menu>
                    <Tooltip label={os === "macos" ? "⌘ + J" : "Ctrl + J"}>
                        <ActionIcon size={42} ml="0.5rem" variant="subtle" onClick={() => toggleColorScheme()}>
                            {colorScheme === "dark" ? <IconSun size={22} /> : <IconMoonStars size={22} />}
                        </ActionIcon>
                    </Tooltip>
                </Flex>
            </Group>
        </Header>
    );
};
